import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { IGif } from "@gtmhub/comments";
import { localize } from "@gtmhub/localization";
import { SizeOfGif } from "@webapp/shared/rich-text-editor/add-gif/add-gif.models";
import { ReflectionQuestion } from "../../models/reflection-question.model";

@Component({
  selector: "reflection-question",
  templateUrl: "./reflection-question.component.html",
  styleUrls: ["./reflection-question.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReflectionQuestionComponent implements OnChanges {
  @Input()
  public question: ReflectionQuestion;

  @Input()
  public isEditModeEnabled = false;

  @Input()
  public autofocus = false;

  @Output()
  public readonly answerUpdate = new EventEmitter<ReflectionQuestion>();

  public answer: string;
  public text: string;
  public placeholder: string;
  public sizeOfGif = SizeOfGif;
  public gif: IGif;

  public ngOnChanges(): void {
    this.answer = this.question.answer;
    this.gif = this.question.gif;
    if (this.question.isDefault) {
      this.text = localize(`checkins_default_${this.question.question}`);
      this.placeholder = localize(`checkins_default_${this.question.question}_placeholder`);
    } else {
      this.text = this.question.question;
      this.placeholder = localize("checkins_question_placeholder");
    }
  }

  public updateQuestion(answer: string): void {
    this.answerUpdate.emit({ ...this.question, answer: answer === "-" ? "" : answer, gif: this.gif });
    this.answer = answer;
  }

  public addDefaultText(): void {
    if (!this.answer) {
      this.answer = "-";
    }
  }

  public gifChange(gif: IGif): void {
    if (gif?.id) {
      this.answerUpdate.emit({ ...this.question, gif });
      this.gif = gif;
      return;
    }

    this.answerUpdate.emit({ ...this.question, gif: null });
    this.gif = null;
  }
}
